export const schemas: Record<string, string[]> = {
  ocean: [
    '#00A61F', // vivid sea green
    '#008E1B',
    '#009155',
    '#009187',
    '#008EB1',
    '#007CA0',
    '#006872',
    '#005E68',
    '#3B5F6B',
    '#2F4858', // deep ocean blue-gray
  ],

  sunset: [
    '#8E5CC2', // twilight purple
    '#AE76DE',
    '#D65DB1',
    '#FF6F91',
    '#FF9671',
    '#FFB36B',
    '#FFC75F',
    '#FFD96A',
    '#F9F871',
    '#FFF9A3', // pale golden sunlight
  ],

  red: [
    '#5C0011', // very dark crimson
    '#800020',
    '#B22222',
    '#C41E3A',
    '#DC143C',
    '#E52B50',
    '#FF2400',
    '#FF4D4D',
    '#FF7F50',
    '#FFB3A7', // soft coral pink
  ],

  orange: [
    '#964000', // burnt orange brown
    '#C65D00',
    '#EB9605',
    '#F76E11',
    '#FF8C1A',
    '#FF9F45',
    '#FFB366',
    '#FFBC80',
    '#FFD1A3',
    '#FFE5CC', // pale peach
  ],

  green: [
    '#1E5631', // deep forest green
    '#2E7D32',
    '#4C9A2A',
    '#68BB59',
    '#76BA1B',
    '#8BC34A',
    '#A4DE02',
    '#ACDF87',
    '#C5E8B7',
    '#E4F7D2', // pale mint
  ],

  blue: [
    '#032F64', // deep navy
    '#034698',
    '#00496C',
    '#006CBB',
    '#1E88E5',
    '#28A7EA',
    '#45BDEE',
    '#74D2F6',
    '#A7E5FF',
    '#DDF5FF', // very light sky blue
  ],

  violet: [
    '#4C197F', // deep indigo
    '#6A1B9A',
    '#7F3E98',
    '#80007E',
    '#9E5FB8',
    '#A02D9C',
    '#B76AC4',
    '#C37ECD',
    '#D7A8E2',
    '#F1DDF8', // pale lavender
  ],

  turquoise: [
    '#0A8F8A', // deep teal
    '#0DDBCC',
    '#19CEEB',
    '#28ACEA',
    '#388EE9',
    '#3D76E0',
    '#43EBFF',
    '#79F2FF',
    '#B5FAFF',
    '#E6FEFF', // icy cyan
  ],

  yellow: [
    '#B88600', // dark goldenrod
    '#EAB200',
    '#F6C616',
    '#F9E231',
    '#FEF54F',
    '#FFF700',
    '#FFFF9F',
    '#FFFCC2',
    '#FFFDE0',
    '#FFFFF2', // near-white cream
  ],

  grey: [
    '#3F4448', // dark charcoal
    '#686E67',
    '#7F8580',
    '#9FA19C',
    '#B1B5BA',
    '#BDBDBB',
    '#D2D5D6',
    '#DEE0E0',
    '#ECEDED',
    '#F7F7F7', // almost white
  ],
};
